import { useAuth } from '../hooks/useAuth'
import type { Permission } from './permissions'
import { can, canAny, canAll } from './can'

/**
 * Hook reactivo: ¿el usuario actual tiene este permiso?
 *
 * Mientras `useAuth().loading` sea `true` devuelve `false` para no autorizar
 * UI sensible antes de saber quién es el usuario.
 */
export function useCan(permission: Permission): boolean {
  const { user, loading } = useAuth()
  if (loading) return false
  return can(user, permission)
}

export function useCanAny(permissions: readonly Permission[]): boolean {
  const { user, loading } = useAuth()
  if (loading) return false
  return canAny(user, permissions)
}

export function useCanAll(permissions: readonly Permission[]): boolean {
  const { user, loading } = useAuth()
  if (loading) return false
  return canAll(user, permissions)
}
